// Operation jobs route (/ops/jobs): active and kind filters in the URL; the screen is JobsPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { zJobKind } from "@/api/__generated__/zod.gen";
import { optionalBoolean, optionalList } from "@/app/search";
import { JobsPage } from "@/features/jobs/JobsPage";

const searchSchema = z.object({
  active: optionalBoolean(),
  kind: optionalList(zJobKind),
});

export const Route = createFileRoute("/_app/ops/jobs/")({
  validateSearch: searchSchema,
  staticData: { crumb: "Jobs" },
  component: JobsPage,
});
